/* eslint-disable lodash/import-scope */
import objectFitImages from "object-fit-images";
import Shadowbox from "shadowbox";
import Spinner from "spin";

window.Viewthespace = window.Viewthespace || {};
window.objectFitImages = objectFitImages;
window.Shadowbox = Shadowbox;
window.jwplayer = {};
window.Spinner = Spinner;

require("rails_admin/jquery-ui/ui/core");
require("rails_admin/jquery-ui/ui/widget");
require("rails_admin/jquery-ui/ui/position");
require("rails_admin/jquery-ui/ui/menu");
require("rails_admin/jquery-ui/ui/autocomplete");
require("shadowbox-en");
require("shadowbox-iframe");
require("shadowbox-jquery");
require("./jwplayer.6.7.edited");
require("jquery.spin");
require("jquery-ujs");
require("lodash");
require("autocomplete-rails");
require("jquery_nested_form");
require("select2");
require("jquery.cookie");
require("jquery.maskedinput");
require("jquery.fancybox");
require("jquery.fancybox-buttons");
require("jquery.fancybox-thumbs");
require("jquery.fancybox-media");
require("jstimezonedetect");
require("set-timezone");
require("./flash");
require("./shadowbox_remote_form_link");
require("./space_detail");
require("@vendor/javascripts/viewthespace_pusher");
require("./spinner");
require("./text_width");
require("./map");
require("./ajax_form_modal");
require("./properties");
require("autonumeric");
require("vts/jquery.iframe-transport");
require("vts/jquery.fileupload");
require("cloudinary/jquery.cloudinary");
require("attachinary");
require("jquery.splendid.textchange");
require("cookies.min");
